import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(({ palette }) => ({
  grid: {
    minHeight: 110,
    padding: 16,
    borderBottom: `1px solid ${palette.grey[300]}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
  },
  icon: {
    width: 55,
    height: 54,
  },
}));

export default useStyles;
